module.exports = __webpack_public_path__ + "img/web.b59fa0d3.svg";